// ============================================================================
// JAPANESE TRANSLATIONS - CHAPTER 2: 出エジプト記
// ============================================================================
// レベル 14-26 (13レベル, 39問)

export const chapter2Translations = {
  name: "出エジプト記",
  description: "神の民の解放……神を知ることは私たちの人生を変える",
  
  spiritualWisdom: {
    principle: "神の知識は解放し、変革する",
    scripture: "あなたがたは真理を知り、真理はあなたがたを自由にします (ヨハネ 8:32)",
    application: "イスラエルがエジプトから解放されたように、神の知識は私たちを霊的奴隷状態から解放します"
  },
  
  levels: {
    14: {
      name: "モーセ、水から救われる",
      challenge: "女は身ごもって、男の子を産んだ。その子が美しいのを見て……",
      easy: {
        question: "モーセの母は彼を何に隠しましたか？",
        options: ["洞窟", "パピルスの籠", "籠", "家"],
        hint: "ナイル川に浮かぶ容器",
        funFact: "🏺 パピルスの籠は防水のために瀝青で塗られていました！"
      },
      medium: {
        question: "葦の中でモーセを見つけたのは誰ですか？",
        options: [
          "ファラオの娘",
          "エジプトの女中",
          "姉のミリアム",
          "エジプトの祭司"
        ],
        hint: "エジプト王家の一員",
        funFact: "👑 皮肉なことに、ファラオの家族が彼に挑戦する者を救いました！"
      },
      hard: {
        question: "神の摂理はどのように敵さえも用いられますか？",
        options: [
          "彼らを改心させることによって",
          "ご自身の目的を成し遂げるために状況を導くことによって",
          "彼らを罰することによって",
          "彼らを無視することによって"
        ],
        hint: "出来事の中に神の手を見ることについてです",
        funFact: "✨ モーセは自分の民を抑圧していた者の宮殿で成長しました！"
      }
    },
    
    15: {
      name: "燃える柴",
      challenge: "主の使いが柴の炎の中で彼に現れた……",
      easy: {
        question: "燃える柴の前でモーセは何を脱がなければなりませんでしたか？",
        options: ["宝石", "サンダル", "外套", "ターバン"],
        hint: "足に履くもの",
        funFact: "👡 靴を脱ぐことは聖なる地への敬意を表します！"
      },
      medium: {
        question: "神はモーセに何という名を明かされましたか？",
        options: [
          "主",
          "わたしはある",
          "全能者",
          "創造者"
        ],
        hint: "絶対的存在を表す名",
        funFact: "🔥 YHWH (わたしはある) は神の永遠の本質を明らかにします！"
      },
      hard: {
        question: "燃えても燃え尽きない柴は何を教えていますか？",
        options: [
          "魔法が存在する",
          "神は自然法則を超越している",
          "火は神聖である",
          "植物は魔法的である"
        ],
        hint: "私たちの理解を超える神の性質についてです",
        funFact: "🌿 柴は神の臨在が破壊せずに聖別することを象徴しています！"
      }
    },

    16: {
      name: "エジプトの十の災い",
      challenge: "ファラオは心をかたくなにし、彼らの言うことを聞かなかった……",
      easy: {
        question: "エジプトの最初の災いは何でしたか？",
        options: ["蛙", "水が血に変わった", "蝿", "虱"],
        hint: "エジプトの命の源であるナイル川に影響を与えました",
        funFact: "🩸 ナイル川は神として崇拝されていましたが、神はその優位性を示されました！"
      },
      medium: {
        question: "最後の最も恐ろしい災いは何でしたか？",
        options: [
          "雹",
          "暗闇",
          "初子の死",
          "いなご"
        ],
        hint: "この災いは家族に直接影響を与えました",
        funFact: "😢 この災いがついにファラオの誇りを砕き、イスラエルを解放しました！"
      },
      hard: {
        question: "なぜ神はファラオの心をかたくなにされたのですか？",
        options: [
          "彼を罰するため",
          "ご自身の栄光と力を現すため",
          "悪意によって",
          "苦しみを長引かせるため"
        ],
        hint: "真の神が誰であるかを明らかにすることについてです",
        funFact: "⚡ 災いはYHWHがすべてのエジプトの神々より強力であることを示しました！"
      }
    },

    17: {
      name: "過越",
      challenge: "羊を取りなさい……その血を鴨居と門柱に塗りなさい……",
      easy: {
        question: "イスラエル人は羊の血をどこに塗るべきでしたか？",
        options: [
          "衣服に",
          "鴨居と門柱に",
          "額に",
          "杯に"
        ],
        hint: "家の入口に",
        funFact: "🩸 扉の血は神の保護のしるしでした！"
      },
      medium: {
        question: "過越の羊をどのように食べるべきでしたか？",
        options: [
          "快適に座って",
          "家族だけで",
          "腰に帯を締め、足にサンダルを履き、手に杖を持って",
          "沈黙のうちに"
        ],
        hint: "出発の準備をして",
        funFact: "🚶 彼らは自由に向かって素早く出発する準備ができていなければなりませんでした！"
      },
      hard: {
        question: "過越の小羊はどのようにキリストを予表していますか？",
        options: [
          "その白さによって",
          "死から救う身代わりの犠牲によって",
          "その優しさによって",
          "その年齢によって"
        ],
        hint: "罪の宣告から免れさせる犠牲についてです",
        funFact: "🐑 イエスは『世の罪を取り除く神の小羊』と呼ばれています！"
      }
    },

    18: {
      name: "紅海の横断",
      challenge: "モーセは海の上に手を差し伸べた……",
      easy: {
        question: "イスラエル人はどのように海を渡りましたか？",
        options: [
          "船で",
          "泳いで",
          "乾いた地を歩いて",
          "筏で"
        ],
        hint: "海底は歩けるようになりました",
        funFact: "🌊 神は障害を解放への道に変えられました！"
      },
      medium: {
        question: "追跡してきたエジプト人に何が起こりましたか？",
        options: [
          "引き返した",
          "水に飲み込まれた",
          "迷子になった",
          "イスラエルに加わった"
        ],
        hint: "水が彼らの上に戻ってきました",
        funFact: "⚔️ 世界で最も強力な軍隊が一瞬で破壊されました！"
      },
      hard: {
        question: "この横断は私たちの霊的生活において何を象徴していますか？",
        options: [
          "問題からの逃避",
          "罪の奴隷状態から神における自由への移行",
          "イスラエルの優越性",
          "敵の破壊"
        ],
        hint: "霊的変革についてです",
        funFact: "🗽 紅海はバプテスマを表しています：古いものへの死、新しい命！"
      }
    },

    19: {
      name: "荒野のマナ",
      challenge: "これは何だろう？彼らはそれが何であるか知らなかったから……",
      easy: {
        question: "マナはどのくらいの期間降りましたか？",
        options: ["10年", "20年", "40年", "50年"],
        hint: "荒野での年数と同じ",
        funFact: "🍞 40年間、神は200万人を奇跡的に養われました！"
      },
      medium: {
        question: "マナを一日以上保存するとどうなりましたか？",
        options: [
          "より美味しくなった",
          "増えた",
          "腐って悪臭を放った",
          "固くなった"
        ],
        hint: "安息日のための金曜日は除く",
        funFact: "🪱 神はこのようにして神への日々の依存を教えられました！"
      },
      hard: {
        question: "マナは信頼について何を教えていますか？",
        options: [
          "将来のために蓄えること",
          "神の日々の摂理に頼ること",
          "もっと一生懸命働くこと",
          "公平に分かち合うこと"
        ],
        hint: "日々信頼することについてです",
        funFact: "🙏 『我らの日用の糧を今日も与えたまえ』はこの経験から来ています！"
      }
    },

    20: {
      name: "岩からの水",
      challenge: "岩を打て、そこから水が出てくる……",
      easy: {
        question: "モーセは岩をどのように打たなければなりませんでしたか？",
        options: ["手で", "杖で", "足で", "剣で"],
        hint: "神が彼に与えた道具",
        funFact: "🪨 単純な服従が超自然的な奇跡を引き起こしました！"
      },
      medium: {
        question: "なぜ人々は喉が渇いていたのですか？",
        options: [
          "暑さのため",
          "砂漠に水がなかったため",
          "長い旅のため",
          "病気のため"
        ],
        hint: "彼らの環境に関することです",
        funFact: "💧 神は乾いた砂漠で水の源を生み出しました！"
      },
      hard: {
        question: "この岩はキリストについて何を予示していますか？",
        options: [
          "その強さ",
          "打たれ、生命の水を与える",
          "その大きさ",
          "その位置"
        ],
        hint: "救いの源に関することです",
        funFact: "⚡ パウロは言いました：『その岩はキリストでした』(1コリント10:4)！"
      }
    },

    21: {
      name: "十戒",
      challenge: "神がこれらすべての言葉を語られた、言って……",
      easy: {
        question: "神はどこで十戒を与えましたか？",
        options: ["エジプトで", "シナイ山で", "カナンで", "砂漠で"],
        hint: "火と煙があった聖なる山",
        funFact: "🔥 神の臨在は山全体を揺るがしました！"
      },
      medium: {
        question: "十戒は何に刻まれましたか？",
        options: [
          "羊皮紙に",
          "神の指で石の板に",
          "木に",
          "金に"
        ],
        hint: "永続的な素材",
        funFact: "👆 神自身がご自分の律法を書かれました！"
      },
      hard: {
        question: "律法の目的は何ですか？",
        options: [
          "人を救うこと",
          "罪を明らかにし、神の聖なる性質を示すこと",
          "人を罰すること",
          "人を奴隷にすること"
        ],
        hint: "神の基準を明らかにすることに関することです",
        funFact: "📜 律法は私たちをキリストへの必要性に導きます！"
      }
    },

    22: {
      name: "金の子牛",
      challenge: "彼らは装飾品を外し、アロンにそれを持って来た……",
      easy: {
        question: "モーセがいない間、人々は何を作りましたか？",
        options: [
          "新しいテント",
          "金の子牛",
          "金の記念碑",
          "新しい祭壇"
        ],
        hint: "偶像崇拝の対象",
        funFact: "🐄 彼らは解放の神を放棄して偶像に仕えました！"
      },
      medium: {
        question: "この罪についてモーセはどう反応しましたか？",
        options: [
          "喜んだ",
          "怒って石の板を壊した",
          "逃げた",
          "無視した"
        ],
        hint: "彼の激しい反応",
        funFact: "😢 神の律法が破られたとき、モーセは律法を破りました！"
      },
      hard: {
        question: "なぜ人間の心は偶像に傾くのですか？",
        options: [
          "無知のため",
          "見えるものに頼りたいという欲望と神の主権への反抗",
          "悪魔の影響のため",
          "弱さのため"
        ],
        hint: "人間の性質と見えるものへの欲望に関することです",
        funFact: "💔 偶像崇拝は創造主を被造物に置き換えます！"
      }
    },

    23: {
      name: "幕屋",
      challenge: "彼らが私のために聖所を作るようにせよ……",
      easy: {
        question: "幕屋は何でしたか？",
        options: [
          "宮殿",
          "神の移動式の聖所",
          "倉庫",
          "学校"
        ],
        hint: "神の臨在のための場所",
        funFact: "⛺ 神はご自分の民の間に住むことを望まれました！"
      },
      medium: {
        question: "幕屋の最も神聖な場所は何でしたか？",
        options: [
          "祭壇",
          "至聖所",
          "入り口",
          "パンの台"
        ],
        hint: "契約の箱があった場所",
        funFact: "✨ 大祭司だけが年に一度そこに入ることができました！"
      },
      hard: {
        question: "幕屋は何を予示していましたか？",
        options: [
          "イスラエルの力",
          "インマヌエル、私たちと共におられる神、キリストによって成就された",
          "祭司の重要性",
          "儀式の美しさ"
        ],
        hint: "人間の間に住まわれる神に関することです",
        funFact: "🙏 イエスは私たちの間に『幕屋を張られた』(ヨハネ1:14)！"
      }
    },

    24: {
      name: "カナンの斥候",
      challenge: "土地とそこにいる人々を探るために人を送れ……",
      easy: {
        question: "カナンを探るために何人の斥候が送られましたか？",
        options: ["6人", "10人", "12人", "24人"],
        hint: "イスラエルの各部族から一人",
        funFact: "🕵️ 12人が送られましたが、2人だけが信仰を持っていました！"
      },
      medium: {
        question: "信仰を持った2人の斥候は誰でしたか？",
        options: [
          "モーセとアロン",
          "ヨシュアとカレブ",
          "アロンとミリアム",
          "ギデオンとサムソン"
        ],
        hint: "カナンに入るために生き残った人々",
        funFact: "💪 彼らの信仰は40年の放浪の後に報われました！"
      },
      hard: {
        question: "不信仰の結果は何でしたか？",
        options: [
          "すぐに赦された",
          "40年間砂漠をさまよった",
          "すぐに罰せられた",
          "追放された"
        ],
        hint: "長い結果",
        funFact: "😢 恐れが世代全体に約束の地への入場を犠牲にさせました！"
      }
    },

    25: {
      name: "青銅の蛇",
      challenge: "燃える蛇が人々の中に入り、彼らを噛んだ……",
      easy: {
        question: "人々を噛んだ蛇はどのような種類でしたか？",
        options: ["緑の", "燃える", "巨大な", "見えない"],
        hint: "彼らの致命的な効果を表す形容詞",
        funFact: "🐍 これらの蛇は罪の致命的な結果を象徴していました！"
      },
      medium: {
        question: "人々を救うために、神はモーセに何をするように命じましたか？",
        options: [
          "薬を作る",
          "竿に青銅の蛇を掲げる",
          "祈る",
          "蛇を殺す"
        ],
        hint: "信仰による行動",
        funFact: "⚕️ 見る単純な行為が救いました - 信仰を象徴しています！"
      },
      hard: {
        question: "イエスは十字架について話すとき、この出来事をどのように引用しましたか？",
        options: [
          "罪の危険性について",
          "『モーセが荒野で蛇を上げたように、人の子も上げられなければならない』",
          "服従の必要性について",
          "祈りの力について"
        ],
        hint: "信じることによる救いに関することです",
        funFact: "✝️ イエスは青銅の蛇のように、罪人を救うために『上げられ』ました！"
      }
    },

    26: {
      name: "約束の地",
      challenge: "あなたの目でそれを見ることができるが、そこに行くことはない……",
      easy: {
        question: "誰がイスラエルをヨルダン川を渡って導きましたか？",
        options: ["モーセ", "アロン", "ヨシュア", "カレブ"],
        hint: "モーセの後継者",
        funFact: "🚶 ヨシュアの名前はイエスと同じ意味です：『主は救う』！"
      },
      medium: {
        question: "なぜモーセは約束の地に入ることができませんでしたか？",
        options: [
          "歳を取りすぎていたため",
          "メリバの水での不従順のため",
          "人々を導くことを拒否したため",
          "病気だったため"
        ],
        hint: "以前の特定の罪",
        funFact: "😢 モーセでさえ不従順の結果に直面しました！"
      },
      hard: {
        question: "約束の地は何を象徴していますか？",
        options: [
          "物質的な豊かさ",
          "キリストにある神の約束の成就と私たちの天の相続",
          "イスラエルの軍事的勝利",
          "砂漠の終わり"
        ],
        hint: "神の約束の霊的成就に関することです",
        funFact: "🌿 カナンは私たちを待っている天の故郷を指しています！"
      }
    }
  }
};

export default chapter2Translations;
